<section class="transfers-map-points">
  <!--Map Modal-->
  <map-modal [mapPoints]="mapPoints"></map-modal>

  <div class="map-container -eva-3-shadow-static" (click)="mapModal.show()">
    <div class="selected-points-title -eva-3-hide-medium-up">{{ 'transfers-map.selectedPoints' | translate }}</div>
    <div class="eva-3-row -no-gutter flex-desktop">
      <div class="col -sm-12 -md-7 -lg-8">
        <div class="map-preview">
          <static-map [staticMaps]="staticMaps">
          </static-map>
        </div>
      </div>
      <div class="col -sm-12 -md-5 -lg-4 desc-column">
        <div class="points-description">
          <div class="selected-points-title -eva-3-hide-small">{{ 'transfers-map.selectedPoints' | translate }}:</div>
          <ul>
            <li>
              <div class="point-description-row">
                <div class="icon-container">
                  <i [ngClass]="isAirportOriginTravelPoint ? 'eva-3-icon-flights-ui' : 'eva-3-icon-poi'"></i>
                </div>
                <div class="text-container">
                  <span>{{ originTravelPoint.description}}</span>
                  <span *ngIf="!isAirportOriginTravelPoint" class="address"> {{originTravelPoint.location.address}}</span>
                </div>
              </div>
            </li>
            <li>
              <div class="point-description-row">
                <div class="icon-container">
                  <i [ngClass]="isAirportDestinationTravelPoint ? 'eva-3-icon-flights-ui' : 'eva-3-icon-poi'"></i>
                </div>
                <div class="text-container">
                  <span>{{destinationTravelPoint.description}}</span>
                  <span *ngIf="!isAirportDestinationTravelPoint" class="address"> {{destinationTravelPoint.location.address}}</span>
                </div>
              </div>
            </li>
          </ul>
          <div class="see-map">
            <a class="eva-3-link" (click)="openModal()">{{ 'transfers-map.viewMap' | translate }}</a>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>